<template>
  <div class="pa-12">
    <v-img
      src="@/static/svg/three-dots.svg"
      height="20"
      contain
      class="my-6"
    ></v-img>
    <h3 class="text-center grey--text" v-text="message"></h3>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: "Please wait. Fetching data just for you ..."
    }
  },
  data() {
    return {};
  }
};
</script>
